const strategyCollection = require('./StrategyCollection');
const policyCollection = require('../TaxAuthority/PolicyCollection');
const roundNumber = require('./Utility/RoundNumber');
const RoundType = require('./Utility/RoundTypeEnum');
const policyService = require('../TaxAuthority/PolicyService');

class Calculation {
    constructor(policy) {
        this.policy = policy && policy.strategy ? policy : policyCollection[policy];
        this.strategy = this.policy && this.policy.strategy ? strategyCollection[this.policy.strategy] : null;
        this.taxAmountRoundDecimals = this.policy && this.policy.taxAmountRoundDecimals !== undefined ? this.policy.taxAmountRoundDecimals : 2;
        this.taxAmountRoundType = this.policy && this.policy.taxAmountRoundType !== undefined ? this.policy.taxAmountRoundType : RoundType.Fair;
    }

    getResult(amount, stake) {
        let taxAmount = 0;
        
        if (this.policy && this.strategy) {
            taxAmount = this.strategy.getTaxAmount(this.policy, amount, stake);
        } 

        return {
            payer: this.policy && this.policy.payer,
            taxAmount: taxAmount,
            taxAmountRounded: roundNumber(taxAmount, this.taxAmountRoundDecimals, this.taxAmountRoundType),
            validation: this.policy && this.policy.validation,
            policy: this.policy && policyService.getPolicyRule(this.policy, amount)
        };
    }
}

module.exports = Calculation;